<template>
    <div class="my-4 mb-8">
        <div class="p-y text-sm">
            <router-link
                v-if="title && url"
                :to="url"
                class="headline-link flex items-center pb-2 font-bold hover:text-blue-600"
            >
                <fa
                    v-if="icon"
                    :icon="icon"
                    class="mr-2"
                />
                {{ $t(title) }}
            </router-link>
            <p
                v-else-if="title"
                class="flex items-center pb-2 font-bold"
            >
                <fa
                    v-if="icon"
                    :icon="icon"
                    class="mr-2"
                />
                {{ $t(title) }}
            </p>
            <ul class="rounded-lg border border-gray-200 bg-white shadow-lg">
                <!-- <slot /> -->
                <SummaryItems :items="items" />
            </ul>
        </div>
    </div>
</template>

<script setup lang="ts">
import { SummaryItems } from '@src/components'
import { SummaryItem } from '@src/types/Summary'
import { RouteLocationRaw } from 'vue-router'

defineProps<{
    title?: string
    url?: RouteLocationRaw
    icon?: string
    items: SummaryItem[]
}>()
</script>
